namespace SPA
{
	export namespace BRW
	{
		export namespace gui
		{

			export class CheckableList
				extends SPA.gui.component.CheckableList
			{

				public constructor( options: SPA.gui.component.CheckableListOptions )
				{
					super( options );
					this.clear();
				}

				public add( ListItems: any, checked?: boolean, options?: SPA.gui.component.CheckableListItemOptions ):
					SPA.gui.component.CheckableListItem
				{

					switch ( ListItems.Item )
					{
						case '1':
						{
							break;
						}
						case '2':
						{
							if (ListItems.Typ === '2')
							{
								ListItems.Item = 2;
							}
							else if (ListItems.Typ === '3')
							{
								ListItems.Item = 3;
							}
							break;
						}
						case '3':
						{
							ListItems.Item = 4;
							break;
						}
					}

					const item = super.add( ListItems.Item + '.' + ListItems.Key, checked, options );

					if ( ListItems.Item < 0 )
					{
						ListItems.Item = -ListItems.Item;
					}

					item
					.append( ui.$$.br() )
					.append( ui.$$.img()
						.css( { width: '100%' } )
						.attr( 'src', 'app/asset/brw/' + ListItems.Item + '_' + ListItems.Key + '.png' ),
					)
					.append( ui.$$.br() ).append( ui.$$.br() )
					.append( ui.$$.text( ListItems.Name ) );

					return item;
				}

			}

		}
	}
}
